import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Link, animateScroll as scroll } from "react-scroll";
import BackgroundImage from 'gatsby-background-image';
import * as Icon from "react-feather";
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const Header = () => {

    const [navigationToggler, setNavigationToggler] = useState(false);

    const handleNavigationToggler = () =>{
        setNavigationToggler(!navigationToggler);
    }

    const scrollToTop = () => {
        scroll.scrollToTop();
    };

    const { image } = useStaticQuery(graphql`
    
        query {
            image: file(relativePath: { eq:"profile.jpg" }) {
            sharp: childImageSharp {
                    fluid {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `);

    return (  
        <nav className={navigationToggler ? "mi-header is-visible" : "mi-header"}>
            <button type="button" onClick={handleNavigationToggler} className="mi-header-toggler" aria-label="Menu">
                {!navigationToggler ? <Icon.Menu /> : <Icon.X />}
            </button>
            <div className="mi-header-inner">
                <div className="mi-header-image">
                    <Link to="/" onClick={scrollToTop}>
                        <BackgroundImage
                            tag="profile"
                            fluid={image.sharp.fluid}
                            fadeIn="soft"
                            className="h-100"
                        >                            
                        </BackgroundImage>
                    </Link>
                </div>
                
                <ul className="mi-header-menu">
                    <li>
                        <Link
                            activeClass="active"
                            to="home"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>Home</span></Link>

                    </li>
                    <li>
                        <Link
                            activeClass="active"
                            to="about"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>About</span></Link>
                    </li>
                    <li>
                        <Link
                            activeClass="active"
                            to="resume"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>Resume</span></Link>
                    </li>
                    <li>
                        <Link
                            activeClass="active"
                            to="portafolios"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>Portfolios</span></Link>
                    </li>
                    <li>
                        <Link
                            activeClass="active"
                            to="posts"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>Posts</span></Link>
                    </li>
                    <li>
                        <Link
                            activeClass="active"
                            to="contact"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                        ><span>Contact</span></Link>
                    </li>
                </ul>
                <div className="d-flex mb-3">
                    <OutboundLink rel="noopener noreferrer" aria-label="Instagram" className="p-2" target="_blank" href="https://www.instagram.com/pabl0dev/">
                        <Icon.Instagram />
                    </OutboundLink>
                    <OutboundLink rel="noopener noreferrer" aria-label="Github" className="p-2" target="_blank" href="https://github.com/Pabl0dev">
                        <Icon.GitHub />
                    </OutboundLink>
                    <OutboundLink rel="noopener noreferrer" aria-label="Linkedin" className="p-2" target="_blank" href="https://www.linkedin.com/in/pablo-mejia-aa4046142/">
                        <Icon.Linkedin />
                    </OutboundLink>
                </div>
            </div>
        </nav>
    );
}
 
export default Header;